export const dataFooter = [
    {
        title: 'Mã màu sơn',
        link: 'https://nipponpaint.com.vn/vi/ma-mau-son/timeless-off-whites'
    },
    {
        title: 'Tìm đại lý',
        link: 'https://nipponpaint.com.vn/vi/dai-ly'
    },
    {
        title: 'Liên hệ',
        link: 'https://nipponpaint.com.vn/vi/lien-he'
    },
]

export const dataHeader = [
    {
        title: 'Xu hướng',
        link: '/xu-huong'
    },
    {
        title: 'Tính năng',
        link: '/tinh-nang'
    },
    {
        title: 'Hệ thống sơn',
        link: '/he-thong-son'
    },
    {
        title: 'Giá sản phẩm',
        link: '/gia'
    },
]


export const dataHeaderLarge = [
    {
        title: 'Giới thiệu',
        link: '/xu-huong'
    },
    {
        title: 'Tính năng',
        link: '/tinh-nang'
    },
    {
        title: 'Hệ thống sơn',
        link: '/he-thong-son'
    },
    {
        title: 'Giá sản phẩm',
        link: '/gia',
        classEffect: 'effect'
    },
]